const BASE_URL = 'https://espanol.cgtn.com/event/2024/05'
export const audios = [
  // 1盘古开天辟地
  {
    title: 'Pan Gu, el creador',
    cover: `${BASE_URL}/pic/01.jpg`,
    audioUrl: `${BASE_URL}/audio/01.mp3`,
    desc: `En esta noche estrellada, te invitamos a ti y a tu hijo/hija a embarcarse en un viaje misterioso y antiguo de mitología china. Algunas historias están enterradas en las dunas del tiempo, mientras que otras brillan sin cesar como estrellas resplandecientes. Ahora, abrimos el pergamino de la historia y exploraremos el mito titulado <i>Pan Gu, el creador.</i>
    Esperamos que, al contar la historia de Pan Gu, no solo podamos transmitir valores y sabiduría a los niños, sino también inspirar su curiosidad e imaginación sobre el mundo, y hacerles comprender que, por muy tortuoso que sea el camino, mientras sean valientes y perseverantes, el final afortunado siempre está por llegar. Ahora, déjanos guiar a los niños a un mundo prehistórico y fantástico ......
    `,
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 2女娲传世造人
  {
    title:'Nüwa, la creadora de la humanidad ',
    cover: `${BASE_URL}/pic/02.jpg`,
    audioUrl: `${BASE_URL}/audio/02.mp3`,
    desc: 'Cuando los hijos nos preguntan con curiosidad de dónde viene todo, los guiamos a explorar el mundo a través de un antiguo y fantástico mito. Compartimos contigo y con los niños una historia sobre cómo nacieron los seres humanos: <i>Nüwa, la creadora de la humanidad.</i>',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 3女娲补天
  {
    title: 'Nüwa restauró el cielo con piedras',
    cover: `${BASE_URL}/pic/03.jpg`,
    audioUrl: `${BASE_URL}/audio/03.mp3`,
    desc: 'Entre las leyendas de China, la historia <i>Nüwa restauró el cielo con piedras</i> se destaca por su encanto único al relatar la conmovedora historia de Nüwa, quien, desafiando las dificultades, repara el cielo y trae la paz al mundo. Es un mito antiguo que es muy conocido en China, y también una de las historias tradicionales más familiares para los niños chinos. Nüwa se enfrenta a los desastres con amor infinito y sentido de responsabilidad, inspirándonos a proteger nuestro mundo con coraje y sabiduría.',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 4神农尝百草
  {
    title: 'Historia del emperador Yan',
    cover: `${BASE_URL}/pic/04.jpg`,
    audioUrl: `${BASE_URL}/audio/04.mp3`,
    desc: 'En la antigua China, después de Nüwa, surgió una gran deidad llamada Shen Nong, también conocido como el emperador Yan. Enseñó al pueblo a cultivar cereales y contribuyó a la construcción de una sociedad armoniosa. Como patrón de la agricultura, creó pozos de agua y un tipo excelente de arroz llamado jiusuihe. También fue un pionero en el campo de la medicina, probando muchos tipos de hierbas y descubriendo su eficacia para tratar enfermedades. Aunque se dice que murió desafortunadamente mientras probaba hierbas, la abnegación de Shen Nong sigue siendo recordada por los chinos. Ahora, compartimos este cuento antiguo y aprendemos de su sabiduría.',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 5皇帝的传说
  {
    title: 'Historia del emperador Amarillo',
    cover: `${BASE_URL}/pic/05.jpg`,
    audioUrl: `${BASE_URL}/audio/05.mp3`,
    desc: 'A lo largo de la extensa historia de China, numerosas leyendas e historias han entrelazado la sabiduría y la creatividad de su pueblo. Entre ellas, el emperador Amarillo es sin duda una de las figuras más influyentes. No solo es considerado el antepasado de la nación china, sino también un símbolo del espíritu de innovación. Junto con el emperador Yan, el emperador Amarillo ha sido la deidad ancestral común del pueblo chino durante miles de años, y los chinos también son conocidos como los "descendientes del emperador Yan y emperador Amarillo". Escuchemos la legendaria historia del emperador Amarillo y exploremos las huellas de la sabiduría antigua. ',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 6后羿射日
  {
    title: 'Hou Yi dispara al sol',
    cover: `${BASE_URL}/pic/06.jpg`,
    audioUrl: `${BASE_URL}/audio/06.mp3`,
    desc: 'En la antigüedad, el mundo vivió un periodo de extrema ansiedad y desesperación. Hou Yi, guerrero y mensajero de la esperanza, abatió nueve soles que amenazaban al mundo y lo salvó de las profundidades del sufrimiento. En esta historia, no solo veremos la intrepidez y la lucha del héroe ante los desastres naturales, sino también la sabiduría del pueblo chino para vivir en armonía con la naturaleza. Les invitamos a adentrarse en esta antigua leyenda china. ',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 7嫦娥奔月
  {
    title: `Chang'e vuela a la luna`,
    cover: `${BASE_URL}/pic/07.jpg`,
    audioUrl: `${BASE_URL}/audio/07.mp3`,
    desc: `La antigua leyenda china Chang'e vuela a la luna no es solo un relato mitológico que se ha transmitido durante miles de años, sino también una profunda revelación de los eternos temas del amor y el sacrificio en la naturaleza humana. 
    Hoy en día, la leyenda no se queda solo en palabras e historias. El proyecto chino de exploración de la Luna, bajo el nombre de Chang'e, ha hecho realidad este mito y ha abierto un nuevo capítulo en la exploración del universo.
    Te invitamos a embarcarte en este antiguo y a la vez moderno viaje para descubrir esta historia de amor y el sueño espacial de China.
    `,
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  },
  // 8龙的故事
  {
    title: 'La leyenda del dragón',
    cover: `${BASE_URL}/pic/08.jpg`,
    audioUrl: `${BASE_URL}/audio/08.mp3`,
    desc: 'En la cultura china, el dragón, o loong en idioma chino, es un símbolo de magia y ha sido un patrimonio cultural desde la antigüedad. Es un portador de innumerables mitos y leyendas, y el orgullo de la cultura nacional de China. En la cultura del país asiático, el dragón es un animal mitológico auspicioso que representa sabiduría y poder. Conozcamos juntos el origen y las bellas leyendas del dragón. ',
    author: '(locutores: Marcela Alvarado/Fu Ruixuan)'
  }
]

export const videos = [
  {
    poster: require('@/assets/v1.png'),
    src: `${BASE_URL}/video/01.mp4`
  }
]